import actionWebInvoke from '../../utils'
import allActions from '../../config.json'

const KEYS = {
  load: 'prj-concurrent-demo/editor-load',
  save: 'prj-concurrent-demo/editor-save',
  formulaGenerate: 'prj-concurrent-demo/formula-generate',
  summaryBoxes: 'prj-concurrent-demo/voting-summary-boxes',
  summaryLayoutSave: 'prj-concurrent-demo/summary-layout-save'
}

function actionUrl (key) {
  const u = allActions[KEYS[key]]
  if (!u) throw new Error(`Missing action URL for ${KEYS[key]} in config.json`)
  return u
}

function imsHeaders (ims) {
  const h = {}
  if (ims && ims.token) h.Authorization = `Bearer ${ims.token}`
  if (ims && ims.org) h['x-gw-ims-org-id'] = ims.org
  return h
}

export function getEditorLoadUrl (pageId) {
  return `${actionUrl('load')}?page_id=${encodeURIComponent(pageId)}`
}

export function getSummaryBoxesUrl () {
  return actionUrl('summaryBoxes')
}

/** POST viewport + box geometry; returns { samples: [{ i, text }] } from current vote stats. */
export async function fetchVotingSummarySamples (viewport, boxes) {
  return actionWebInvoke(
    actionUrl('summaryBoxes'),
    {},
    { viewport, boxes },
    { method: 'POST' }
  )
}

export async function loadEditorState (pageId) {
  return actionWebInvoke(actionUrl('load'), {}, { page_id: pageId }, { method: 'GET' })
}

export async function saveEditorState (ims, pageId, linkPanels, screenshotUrl) {
  return actionWebInvoke(
    actionUrl('save'),
    imsHeaders(ims),
    { pageId, linkPanels, screenshotUrl },
    { method: 'POST' }
  )
}

export async function generateFormula (prompt, sampleValue) {
  return actionWebInvoke(
    actionUrl('formulaGenerate'),
    {},
    { prompt, sample_value: sampleValue },
    { method: 'POST' }
  )
}

export async function saveSummaryLayoutCalibration (ims, calibration, secret) {
  const body = { calibration }
  if (secret != null && String(secret).length > 0) body.secret = String(secret)
  return actionWebInvoke(
    actionUrl('summaryLayoutSave'),
    imsHeaders(ims),
    body,
    { method: 'POST' }
  )
}
